/* eslint-disable no-restricted-globals */
import { parseCookie } from "../../payment/miscellaneous/parseCookie";
import { languageSupport } from "./languageDetails";

/* eslint-disable functional/no-conditional-statement */
export async function languageFromNavigator() {
  const languageCookie = parseCookie(document.cookie)["MkHcLang"];

  // eslint-disable-next-line no-restricted-globals
  const locationParams = new URLSearchParams(location.search);
  const langParam = locationParams.get("lang");

  const languagePrefix = location.pathname.split("/")[1];

  if (!!languageCookie && langParam === null) {
    return languageCookie.toLowerCase();
  }

  if (!!langParam) {
    return (await languageSupport()).includes(langParam.toLowerCase())
      ? langParam.toLowerCase()
      : "en";
  }

  // Check if language on url not map with en or jp. It auto take "en" value.
  return (await languageSupport()).includes(languagePrefix.toLowerCase())
    ? languagePrefix.toLowerCase()
    : "en";
}
